import React from "react"
import { v4 as uuidv4 } from "uuid"
import {
  AiFillFacebook,
  AiOutlineTwitter,
  AiFillInstagram,
} from "react-icons/ai"

export const navbar = [
  {
    id: uuidv4(),
    title: "Home",
    url: "/",
  },
  {
    id: uuidv4(),
    title: "About",
    url: "/about-us",
  },
  {
    id: uuidv4(),
    title: "Gallery",
    url: "/gallery",
  },
  {
    id: uuidv4(),
    title: "Contact Us",
    url: "/contact-us",
  },
]

export const socials = [
  {
    id: uuidv4(),
    icon: <AiFillFacebook />,
    url: "https://facebook.com",
  },
  {
    id: uuidv4(),
    icon: <AiOutlineTwitter />,
    url: "https://twitter.com/tsbsankara",
  },
  {
    id: uuidv4(),
    icon: <AiFillInstagram />,
    url: "https://instagram.com",
  },
]

export const homeCards = [
  {
    id: uuidv4(),
    title: "Permanent home",
    image: "./images/permanent-home.svg",
    desc: "Now led tedious shy lasting females off. Dashwood marianne in of entrance be on wondered possible building. Wondered sociable he carriage in speedily margaret. Up devonshire of he thoroughly insensible alteration.",
    button: "Learn More",
    url: "/",
  },
  {
    id: uuidv4(),
    title: "Vacation home",
    image: "./images/vacation-home.svg",
    desc: "Now led tedious shy lasting females off. Dashwood marianne in of entrance be on wondered possible building. Wondered sociable he carriage in speedily margaret. Up devonshire of he thoroughly insensible alteration.",
    button: "Learn More",
    url: "/",
  },
  {
    id: uuidv4(),
    title: "Guaranteed",
    image: "./images/bank.svg",
    desc: "Now led tedious shy lasting females off. Dashwood marianne in of entrance be on wondered possible building. Wondered sociable he carriage in speedily margaret. Up devonshire of he thoroughly insensible alteration.",
    button: "Learn More",
    url: "/",
  },
]

export const homes = [
  {
    id: uuidv4(),
    image: "./images/home-1.jpg",
    title: "Bahamas",
    desc: "Now led tedious shy lasting females off. Dashwood marianne in of entrance be on wondered possible building. Wondered sociable he carriage in speedily margaret. Up devonshire of he thoroughly insensible alteration. Now led tedious shy lasting females off. Dashwood marianne in of entrance be on wondered possible building. Wondered sociable he carriage in speedily margaret. Up devonshire of he thoroughly insensible alteration.",
    url: "/",
  },
  {
    id: uuidv4(),
    image: "./images/home-2.jpg",
    title: "Aruba",
    desc: "Now led tedious shy lasting females off. Dashwood marianne in of entrance be on wondered possible building. Wondered sociable he carriage in speedily margaret. Up devonshire of he thoroughly insensible alteration. Now led tedious shy lasting females off. Dashwood marianne in of entrance be on wondered possible building. Wondered sociable he carriage in speedily margaret. Up devonshire of he thoroughly insensible alteration.",
    url: "/",
  },
  {
    id: uuidv4(),
    image: "./images/home-3.jpg",
    title: "Mombasa",
    desc: "Now led tedious shy lasting females off. Dashwood marianne in of entrance be on wondered possible building. Wondered sociable he carriage in speedily margaret. Up devonshire of he thoroughly insensible alteration. Now led tedious shy lasting females off. Dashwood marianne in of entrance be on wondered possible building. Wondered sociable he carriage in speedily margaret. Up devonshire of he thoroughly insensible alteration.",
    url: "/",
  },
  {
    id: uuidv4(),
    image: "./images/home-4.jpg",
    title: "Jamaica",
    desc: "Now led tedious shy lasting females off. Dashwood marianne in of entrance be on wondered possible building. Wondered sociable he carriage in speedily margaret. Up devonshire of he thoroughly insensible alteration. Now led tedious shy lasting females off. Dashwood marianne in of entrance be on wondered possible building. Wondered sociable he carriage in speedily margaret. Up devonshire of he thoroughly insensible alteration.",
    url: "/",
  },
]

export const galleryImages = [
  {
    id: uuidv4(),
    image: "./images/gallery-1.jpg",
  },
  {
    id: uuidv4(),
    image: "./images/gallery-2.jpg",
  },
  {
    id: uuidv4(),
    image: "./images/gallery-3.jpg",
  },
  {
    id: uuidv4(),
    image: "./images/gallery-4.jpg",
  },
  {
    id: uuidv4(),
    image: "./images/gallery-5.jpg",
  },
  {
    id: uuidv4(),
    image: "./images/gallery-6.jpg",
  },
]
